import { Component, Input } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ParcoursFormationUtilisateurModel, PackageScormUtilisateurParcoursFormationModel } from 'src/models/parcoursFormationUtilisateurModel';
import { ScormPackageLocaleModel } from 'src/models/scormPackageModel';
import { ScormPackageModel } from 'src/models/scormPackageModel';

@Component({
    selector: 'app-parcours-formation-card',
    templateUrl: './parcours-formation-card.component.html',
    styleUrls: ['./parcours-formation-card.component.scss'],
    imports: [
    RouterModule,
    TranslateModule
]
})
export class ParcoursFormationCardComponent {
  @Input() parcours!: ParcoursFormationUtilisateurModel;
  @Input() showDescriptionFn!: (scormPackage: ScormPackageModel) => void;
  @Input() estServiceStudio: boolean = false;
  @Input() estServiceStudioContenusPerso: boolean = false;

  constructor(public translate: TranslateService) { }

  private estPackagePerso(pkg: ScormPackageModel): boolean {
    return pkg.entitePackagePerso != null;
  }

  private estPackageLegacy(pkg: ScormPackageModel): boolean {
    return pkg.entitePackagePerso?.estLegacy === true;
  }

  get filteredPackages(): PackageScormUtilisateurParcoursFormationModel[] {
    const aServiceStudio = this.estServiceStudio ?? false;
    const aServicePerso = this.estServiceStudioContenusPerso ?? false;

    if (aServiceStudio && aServicePerso) {
      return this.parcours.packages;
    }

    if (aServiceStudio) {
      return this.parcours.packages.filter(pkg => !this.estPackagePerso(pkg.scormPackage) || this.estPackageLegacy(pkg.scormPackage));
    }

    if (aServicePerso) {
      return this.parcours.packages.filter(pkg => this.estPackagePerso(pkg.scormPackage));
    }

    return [];
  }

  getLocalizedContent(locales: ScormPackageLocaleModel[]): ScormPackageLocaleModel {
    const currentLang = this.translate.currentLang || 'fr';
    return locales.find(locale => locale.langue.toLowerCase() === currentLang) || locales[0];
  }

  getNextPackage(): PackageScormUtilisateurParcoursFormationModel | undefined {
    return this.filteredPackages.find(p => !p.estComplete);
  }

  getLocalizedNom(parcours: ParcoursFormationUtilisateurModel): string {
    const currentLang = this.translate.currentLang || 'fr';
    return (parcours as any).locales[currentLang] ||
      (parcours as any).locales['fr'] ||
      (parcours as any).locales['en'] ||
      (parcours as any).locales['es'] ||
      '';
  }

  calculateProgress(): number {
    const packages = this.filteredPackages;
    if (!packages || packages.length === 0) {
      return 0;
    }
    const completedPackages = packages.filter(p => p.estComplete).length;
    const totalPackages = packages.length;
    return Math.round((completedPackages / totalPackages) * 100);
  }

  getCompletedCount(): number {
    return this.filteredPackages.filter(p => p.estComplete).length;
  }

  getTotalCount(): number {
    return this.filteredPackages.length;
  }

  getCompletedDuration(): number {
    return this.filteredPackages
      .filter(p => p.estComplete)
      .reduce((total, pkg) => total + this.getLocalizedContent(pkg.scormPackage.locales).dureeEnMinutes, 0);
  }

  getTotalDuration(): number {
    return this.filteredPackages
      .reduce((total, pkg) => total + this.getLocalizedContent(pkg.scormPackage.locales).dureeEnMinutes, 0);
  }

  calculateDurationProgress(): number {
    const packages = this.filteredPackages;
    if (!packages || packages.length === 0) {
      return 0;
    }
    const completedDuration = this.getCompletedDuration();
    const totalDuration = this.getTotalDuration();
    return totalDuration > 0 ? Math.round((completedDuration / totalDuration) * 100) : 0;
  }
}
